import React, { useState } from "react";
import { useAuth } from "../lib/auth";
import { Truck, Menu, LogOut, X } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function ManagerHeader() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  return (
    <div className="bg-primary text-primary-foreground" data-testid="manager-header">
      <div className="max-w-2xl mx-auto px-5 py-5 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-white/15 flex items-center justify-center">
            <Truck size={22} strokeWidth={2.4} />
          </div>
          <div className="leading-tight">
            <div className="font-display text-xl font-bold">LedgerFlow</div>
            <div className="text-xs text-white/70">Factory Manager · {user?.name}</div>
          </div>
        </div>
        <button
          onClick={() => setOpen((v) => !v)}
          data-testid="manager-menu-button"
          className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center hover:bg-white/20 transition"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {open ? (
        <div className="max-w-2xl mx-auto px-5 pb-4">
          <button
            data-testid="manager-logout-btn"
            onClick={async () => { await logout(); nav("/login"); }}
            className="w-full text-left px-3 py-2 rounded-lg bg-white/10 hover:bg-white/15 flex items-center gap-2"
          >
            <LogOut size={16} /> Sign out
          </button>
        </div>
      ) : null}
    </div>
  );
}
